import React, { useEffect, useState } from 'react';
import { Id, toast } from 'react-toastify';
import { notify, UiButton, UiIcon, UiText } from 'znanie-uikit';

import { useMediaQueries } from 'hooks/utils/useMediaQueries';

import css from './Interview.module.scss';

export default function InterviewWidget() {
  const { isMobile } = useMediaQueries();
  const [toastId, setToastId] = useState<Id | undefined>('interview');
  const component = (
    <div className={css.interview}>
      <UiText size="small_plus">Помогите нам стать к Вам ближе</UiText>
      <UiButton
        className={css.interviewBtn}
        as="a"
        variant="primary"
        size="small"
        href="https://sst.gl/znanie_web"
        target="_blank"
        onClick={() => toast.dismiss(toastId)}
      >
        Пройти опрос
      </UiButton>
    </div>
  );

  useEffect(() => {
    if (toastId) {
      notify(component, {
        type: 'info',
        icon: false,
        autoClose: false,
        closeOnClick: false,
        toastId,
        style: {
          padding: '18px 12px 22px 20px',
          width: 320,
          marginLeft: 'auto',
          marginRight: isMobile ? 15 : 0,
          top: '1em',
          boxSizing: 'border-box',
          borderLeft: '7px solid #426fff',
        },
        delay: 5000,
        onClose: () => setToastId(undefined),
        closeButton: ({ closeToast }) => (
          <UiIcon
            name="close"
            width={13}
            height={13}
            className={css.interviewCloseBtn}
            onClick={closeToast}
          />
        ),
      });
    }
  }, [toastId]);

  return null;
}
